const conditions = () => {
  return [
    {
      assetClass: {
        $in: {
          'object.asset-class.options.wohnen': 'object.required-information-and-documents.living.options',
          'object.asset-class.options.handel-retail': 'object.required-information-and-documents.living.options',
          'object.asset-class.options.hotel': 'object.required-information-and-documents.living.options',
          'object.asset-class.options.healthcare-medical': 'object.required-information-and-documents.living.options',
          'object.asset-class.options.buero': 'object.required-information-and-documents.living.options',
          'object.asset-class.options.logistik-industrie': 'object.required-information-and-documents.living.options',
          'object.asset-class.options.micro-und-serviced-living': 'object.required-information-and-documents.living.options',
          'object.asset-class.options.freies-ankaufsprofil': 'object.required-information-and-documents.living.options',
          'object.asset-class.options.kapitalgeber': 'object.required-information-and-documents.living.options',
        },
      },
    },
  ]
}

export default conditions
